export enum Warnings {
    COURSE_BLOCKED = 'COURSE_BLOCKED',
    COURSE_EXPIRED = 'COURSE_EXPIRED',
    COURSE_NEARLY_EXPIRED = 'COURSE_NEARLY_EXPIRED',
    TEST_COURSE_EXPIRED = 'TEST_COURSE_EXPIRED',
    TEST_COURSE_NEARLY_EXPIRED = 'TEST_COURSE_NEARLY_EXPIRED',
    NO_COURSE_BOOKED = 'NO_COURSE_BOOKED',
    REPETITORIUM_MIGRATION_AVAILABLE = 'REPETITORIUM_MIGRATION_AVAILABLE'
}
